import { useQuery } from '@tanstack/react-query';
import * as projectService from '../services/project.service';

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: projectService.getAllProjects,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

export function useProject(projectId: string) {
  return useQuery({
    queryKey: ['project', projectId],
    queryFn: () => projectService.getProjectById(projectId),
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000,
  });
}
